import styled from 'styled-components';

const StyledTagLabel = styled.strong`
  display: inline-block;
  color: ${(props) => props.theme.colors.white};
  margin: 0;
  padding: 10px 16px;
  border-radius: 8px 8px 0 0;
`;

const Recommended = styled(StyledTagLabel)`
  background: ${(props) => props.theme.colors.verticalgradients.success};
`;

const Alternative = styled(StyledTagLabel)`
  color: ${(props) => props.theme.colors.altText};
  background: ${(props) => props.theme.colors.verticalgradients.alternative};
`;

StyledTagLabel.Recommended = Recommended;
StyledTagLabel.Alternative = Alternative;

export default StyledTagLabel;
